import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { ProductForm } from '@/components/admin/ProductForm';
import { createProduct } from '@/lib/admin/products';
import { Product } from '@/types';
import AdminLayout from '@/components/admin/AdminLayout';
import { useAuth } from '@/context/AuthContext';
import { useEffect } from 'react';
import { Container, Loader, Center } from '@mantine/core';

export default function AdminProductNewPage() {
  const navigate = useNavigate();
  const { user, isAdmin: isAdminUser, loading: authLoading } = useAuth();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!authLoading && (!user || !isAdminUser)) {
      navigate('/xyz/login');
    }
  }, [user, isAdminUser, authLoading, navigate]);

  const handleSubmit = async (data: Partial<Product>) => {
    setLoading(true);
    try {
      await createProduct(data as Omit<Product, 'id' | 'createdAt' | 'updatedAt'>);
      notifications.show({
        title: 'Success',
        message: 'Product created successfully',
        color: 'green',
      });
      navigate('/xyz/products');
    } catch (error: any) {
      notifications.show({
        title: 'Error',
        message: error.message || 'Failed to create product',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/xyz/products');
  };

  if (authLoading) {
    return (
      <AdminLayout>
        <Container size="xl" py="xl">
          <Center h="50vh">
            <Loader size="lg" />
          </Center>
        </Container>
      </AdminLayout>
    );
  }

  if (!user || !isAdminUser) {
    return null;
  }

  return (
    <AdminLayout>
      <ProductForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
      />
    </AdminLayout>
  );
}
